import React, { useState } from 'react';
import styles from './LeftSideNav.module.css';
import Logo from '../Logo/Logo';
import SideNavAccordion from '../Navigation/SideNavAccordion/SideNavAccordion';
import Footer from '../Footer/Footer';
import lvLogo from '../../assets/images/lv-logo.svg';

const LeftSideNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className={styles.leftSideNavHamburgerContainer}>
        {/* Hamburger button - visible only on small screens */}
        <button 
          className={styles.hamburgerButton} 
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          <span className={`${styles.hamburgerIcon} ${isOpen ? styles.open : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <img src={lvLogo} alt="Logo" />
      </div>

      {/* Overlay backdrop - visible when menu is open on small screens */}
      {isOpen && (
        <div 
          className={styles.overlay} 
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      {/* Navigation sidebar */}
      <nav className={`${styles.leftSideNav} ${isOpen ? styles.navOpen : ''}`}>
        <Logo />
        <SideNavAccordion />    
        <Footer />
      </nav>
    </>
  );
};

export default LeftSideNav;
